// import Swiper JS
import Swiper from 'swiper/bundle';

export default class SwiperEvent {
  constructor() {
    this.init();
  }
  init() {
    // .PlayerScheduleSlide
    // if (document.querySelector('.swiper-movie')) {
    //   const movieSwiper = new Swiper('.swiper-movie', {
    //     loop: true,
    //     speed: 1000,
    //     spaceBetween: 60,
    //     slidesPerView: 1.05,
    //     effect: 'creative',
    //     creativeEffect: {
    //       prev: {
    //         translate: ['-110%', 0, 1],
    //         opacity: 1,
    //         scale: 0.8,
    //         shadow: false,
    //         // origin: 'right bottom',
    //       },
    //       next: {
    //         translate: ['110%', 0, 1],
    //         opacity: 1,
    //         scale: 0.8,
    //         shadow: false,
    //         // origin: 'left bottom',
    //       },
    //       limitProgress: 2,
    //       perspective: true,
    //     },
    //     breakpoints: {
    //       // 768px以上の場合
    //       768: {
    //         spaceBetween: 3,
    //         slidesPerView: 1.8,
    //       },
    //     },
    //     centeredSlides: true,
    //     pagination: {
    //       el: '.TopPageMovieSlide .swiper-pagination',
    //       clickable: true,
    //     },
    //     navigation: {
    //       nextEl: '.TopPageMovieSlide .TopPageSlideNavL',
    //       prevEl: '.TopPageMovieSlide .TopPageSlideNavR',
    //     },
    //   });
    // }

    if (document.querySelector('.swiper-about')) {
      const aboutSwiper = new Swiper('.swiper-about', {
        loop: true,
        speed: 1000,
        spaceBetween: 60,
        slidesPerView: 1.5,
        autoplay: {
          delay: 5000,
        },
        effect: 'creative',
        creativeEffect: {
          prev: {
            translate: ['-110%', 0, 1],
            opacity: 1,
            scale: 0.8,
            shadow: false,
            // origin: 'right bottom',
          },
          next: {
            translate: ['110%', 0, 1],
            opacity: 1,
            scale: 0.8,
            shadow: false,
            // origin: 'left bottom',
          },
          limitProgress: 2,
          perspective: true,
        },
        breakpoints: {
          // 768px以上の場合
          768: {
            autoplay: false,
            slidesPerView: 2.8,
          },
        },
        centeredSlides: true,
        pagination: {
          el: '.TopPageAboutSlide .swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.TopPageAboutSlide .TopPageSlideNavR',
          prevEl: '.TopPageAboutSlide .TopPageSlideNavL',
        },
      });
    }
  }
}
